<script setup lang="ts">
import { IconoirProvider } from "@iconoir/vue";
import { onMounted } from "vue";

const { $api } = useNuxtApp();
const authStore = useAuthStore();
const { user, token } = storeToRefs(authStore);

const iconoirOptions = {
  color: "currentColor",
  strokeWidth: 2,
  width: "1.25em",
  height: "1.25em",
  key: "iconoir",
};

function loadProfile() {
  return $api("/profile", {
    method: "GET",
  }).then((resp: any) => {
    authStore.user = resp;
  });
}

onMounted(() => {
  if (!user.value && token.value) {
    loadProfile().catch((err) => {
      console.log(err);
      authStore.logout();
      navigateTo("/login");
    });
  }
});
</script>

<template>
  <AlertProvider>
    <ToastProvider>
      <IconoirProvider :icon-props="iconoirOptions">
        <NuxtLayout>
          <NuxtPage />
        </NuxtLayout>
      </IconoirProvider>
    </ToastProvider>
  </AlertProvider>
</template>
